import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { trackConsultantMotivationPopupClick, trackConsultantMotivationPopupShown } from './analytics';
import { motivationPopupOpenSelector } from '../../../selectors/newbuildingConsultant';
import { MotivationConsultantPopup } from '../../../serp/components/MotivationConsultantPopup';
import { newbuildingChatOpenToggle, newbuildingOpenMotivationToggle } from '../../../serp/state/newbuildingConsultant';
import { TThunkDispatch } from '../../../types/redux';

export function MotivationConsultantPopupContainer() {
  const isOpen = useSelector(motivationPopupOpenSelector);
  const dispatch = useDispatch<TThunkDispatch>();
  const content = React.useMemo(
    () => ({
      title: 'Нужно найти квартиру\nв новостройке?',
      text: 'Консультанты Циан помогут быстро подобрать лучшее предложение',
      buttonText: 'Начать диалог',
    }),
    [],
  );

  React.useEffect(() => {
    if (isOpen) {
      trackConsultantMotivationPopupShown();
    }
  }, [isOpen]);

  const close = React.useCallback(() => dispatch(newbuildingOpenMotivationToggle(false)), [dispatch]);
  const onClick = React.useCallback(() => {
    trackConsultantMotivationPopupClick();
    dispatch(newbuildingChatOpenToggle(true));
  }, [dispatch]);

  if (!isOpen) {
    return null;
  }

  return <MotivationConsultantPopup content={content} onClick={onClick} onClose={close} />;
}
